import { UserModel } from './user.model';
import { CompanyModel } from './company.model';

export class UserCompanyModel {
    user_company_id: number;
    user_id: number;
    company_id: number;
    user?: UserModel;
    company?: CompanyModel;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: Partial<UserCompanyModel>) {
        this.user_company_id = data?.user_company_id ?? null;
        this.user_id = data?.user_id ?? null;
        this.company_id = data?.company_id ?? null;
        this.user = data?.user ?? null;
        this.company = data?.company ?? null;
        this.createdAt = data?.createdAt ? new Date(data.createdAt) : null;
        this.updatedAt = data?.updatedAt ? new Date(data.updatedAt) : null;
    }
}

